// extracted by mini-css-extract-plugin
module.exports = {"cardsWrapper":"Card_cardsWrapper__1LDBp","card":"Card_card__1eE8R","preview":"Card_preview__34tlp"};